import axios from 'axios'
import ActionsLogin from './LoginActions'

const config = {
  headers: {
    Authorization: 'Bearer ' + ActionsLogin.getToken()
  }
}

const backend = '/dashboard/'

const listarCampanhas = async () => {
  let response = await axios.get(
    process.env.URL_API_BASE + backend + 'listar-campanhas/',
    config
  )
  return response.data
}

const pesquisar = async pesquisa => {
  let response = await axios.get(
    process.env.URL_API_BASE + backend + pesquisa,
    config
  )
  return response.data
}

export default {
  listarCampanhas,
  pesquisar
}



// WEBPACK FOOTER //
// ./src/actions/DashboardActions.js